export const subheaders = {
	campaignsList: 'campaignsList',
	campaignManagement: 'campaignManagement',
	campaignManagementSidebarManualAssign: 'campaignManagementSidebarManualAssign',
	campaignRegionNominations: 'campaignRegionNominations',
	campaignsNearingTheEnd: 'campaignsNearingTheEnd',
	campaignsNearingTheEndManager: 'campaignsNearingTheEndManager',
	campaignsNearingTheEndContactRelease: 'campaignsNearingTheEndContactRelease',
	campaignSubsellerNominations: 'campaignSubsellerNominations',
	contactHistory: 'contactHistory',
	contacts: 'contacts',
	currentCampaigns: 'currentCampaigns',
	escalationBasic: 'escalationBasic',
	escalationSummary: 'escalationSummary',
	leadsToProcess: 'leadsToProcess',
	marketPlace: 'marketPlace',
	policyOverview: 'policyOverview',
	producedProduction: 'producedProduction',
	roboAdvisory: 'roboAdvisory',
	semaphore: 'semaphore',
	subordinateUsers: 'subordinateUsers',
	taskSearch: 'taskSearch',
	taskStatistics: 'taskStatistics',
	tasksOverview: 'tasksOverview',
	unlockedClients: 'unlockedClients',
};
